import React from 'react'
import Modal from 'components/Modal'
import Close from 'components/Close'
import { Mutation } from 'react-apollo'
import { CREATE_STORAGE_ALIAS, GET_STORAGE_ALIASES } from 'operations/Object'
import { Fieldset, Input, Submit } from 'components/Form'
import jwtDecode from 'jwt-decode'

export default class AddSource extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            alias: '',
            directory: '',
            token: localStorage.getItem('accessToken') || null,
        }

        this.handleChange = this.handleChange.bind(this)
        this.handleClose = this.handleClose.bind(this)
    }

    handleClose(e) {
        if (this.props.onClose) {
            this.props.onClose(e)
        }
    }

    handleChange = ({ target: { name, value } }) => {
        if (name === 'alias') {
            value = value.replace(/[^a-z0-9]/gi,'')
        }
        this.setState({
            [name]: value
        })
    }

    render() {

        const { aID } = jwtDecode(this.state.token)

        return(
            <Modal>
                
                <Close onClick={ this.handleClose } />
                <div className='modal__form'>
                    <h1>Let's add a source</h1>

                    <Mutation mutation={ CREATE_STORAGE_ALIAS } refetchQueries={[{ query: GET_STORAGE_ALIASES }]} >
                        {( createStorageAlias, { data } ) => (
                            <form onSubmit={(e) => {
                                e.preventDefault()

                                createStorageAlias({
                                    variables: {
                                        data: {
                                            alias: this.state.alias,
                                            directory: this.state.directory
                                        }
                                    }
                                })
                                .then(({data}) => {
                                    this.setState({
                                        alias: '',
                                        directory: ''
                                    })
                                    this.handleClose()
                                })
                                .catch(err => {
                                    console.log(err)
                                })
                                
                            }}>
                                <Fieldset legend='Remote source'>
                                    <Input name='alias' label='Source name' helper='Alphanumeric' value={ this.state.alias } onChange={ this.handleChange } autocomplete='off' />
                                    <span style={{ color: 'rgba(0,0,0,0.5)' }}>https://cdn.tueri.io/{ aID }/<strong style={{ color: 'rgba(0,0,0,0.8)' }}>{ this.state.alias || 'SourceName' }</strong>/</span>
                                    <Input name='directory' label='Remote path' helper='https://example.com/path/to/your_images/' value={ this.state.directory } onChange={ this.handleChange } autocomplete='off' />
                                    <Submit value='Add source'/>
                                </Fieldset>
                            </form>    
                        )}
                    </Mutation>
                </div>
            </Modal>
        )

    }

}


// WEBPACK FOOTER //
// ./src/components/AddSource/index.js